import { gql } from '@apollo/client';

export const QUERY_FORMATIONS = gql`
  query AllFormationsAndTypes {
    formations(sort: "order:asc") {
      data {
        id
        attributes {
          name
          subtitle
          info
          desc
          reservedToProf
          formation_type {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
    findFormationTypeWithRelatedFormations {
      id
      name
      formations {
        name
      }
    }
  }
`;
